(function () {

  /* ----------------------------------------------------------
     Desktop tab activation
     ---------------------------------------------------------- */
  function activateDesktopTab(tabId) {
    if (!tabId) return;
    tabId = tabId.replace('#', '');

    const tabs = document.querySelectorAll('.desktop-megamenu .dtab');
    const panes = document.querySelectorAll('.desktop-megamenu .tab-pane');
    if (!tabs.length || !panes.length) return;

    tabs.forEach(t => t.classList.remove('active'));
    panes.forEach(p => p.classList.remove('active'));

    const targetBtn = document.querySelector(`.desktop-megamenu .dtab[data-target="${tabId}"]`);
    const targetPane = document.getElementById(tabId);

    if (targetBtn) targetBtn.classList.add('active');
    if (targetPane) targetPane.classList.add('active');
  }

  function initDesktopTabs() {
    const tabs = document.querySelectorAll('.desktop-megamenu .dtab');
    const panes = document.querySelectorAll('.desktop-megamenu .tab-pane');
    if (!tabs.length || !panes.length) return false;

    const savedTab = localStorage.getItem('pdp_open_tab');
    if (savedTab) {
      activateDesktopTab(savedTab);
      setTimeout(() => localStorage.removeItem('pdp_open_tab'), 500);
    } else {
      activateDesktopTab(tabs[0].dataset.target);
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        activateDesktopTab(tab.dataset.target);
        localStorage.setItem('pdp_open_tab', tab.dataset.target);
      });
    });

    return true;
  }

  /* ----------------------------------------------------------
     Mobile tab activation
     ---------------------------------------------------------- */
  function activateMobileTab(tabId) {
    if (!tabId) return;
    tabId = tabId.replace('#', '');

    const tabs = document.querySelectorAll('.drawer-collection .tab');
    const panes = document.querySelectorAll('.drawer-collection .tab-pane-mobile');
    if (!tabs.length || !panes.length) return;

    tabs.forEach(t => t.classList.remove('active'));
    panes.forEach(p => p.classList.remove('active'));

    const targetBtn = document.querySelector(`.drawer-collection .tab[data-target="${tabId}"]`);
    const targetPane = document.getElementById(tabId);

    if (targetBtn) targetBtn.classList.add('active');
    if (targetPane) targetPane.classList.add('active');
  }

  function initMobileTabs() {
    const tabs = document.querySelectorAll('.drawer-collection .tab');
    const panes = document.querySelectorAll('.drawer-collection .tab-pane-mobile');
    if (!tabs.length || !panes.length) return false;

    const savedTab = localStorage.getItem('pdp_open_tab_mobile');
    if (savedTab) {
      activateMobileTab(savedTab);
      localStorage.removeItem('pdp_open_tab_mobile');
    } else {
      activateMobileTab(tabs[0].dataset.target);
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        activateMobileTab(tab.dataset.target);
        localStorage.setItem('pdp_open_tab_mobile', tab.dataset.target);
      });
    });

    return true;
  }

  /* ----------------------------------------------------------
     Product link clicks — save tab position to localStorage
     ---------------------------------------------------------- */
  function initProductLinks() {
    document.querySelectorAll('.product-tab-link').forEach(link => {
      link.addEventListener('click', () => {
        const pos = link.dataset.tab;
        if (!pos) return;
        localStorage.setItem('pdp_open_tab', 'mega-tab-' + pos);
        localStorage.setItem('pdp_open_tab_mobile', 'mob-tab-' + pos);
      });
    });
  }

  /* ----------------------------------------------------------
     Init
     ---------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    initProductLinks();
    initMobileTabs();

    if (initDesktopTabs()) return;

    let tries = 0;
    const interval = setInterval(() => {
      tries++;
      if (initDesktopTabs() || tries > 25) clearInterval(interval);
    }, 200);
  });

})();
